import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withMethods, withState, patchState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { exhaustMap, pipe, tap } from 'rxjs';

import { Region } from '@regions/models/region';
import { RegionsService } from '@regions/services/regions.service';
import { ToastNotificationsService } from '@shared/services/toast-notifications.service';

interface RegionsState {
  data: Region[];
  loading: boolean;
  loaded: boolean;
  error: HttpErrorResponse | null;
}

const INITIAL_STATE: RegionsState = {
  data: [],
  loading: false,
  loaded: false,
  error: null
};

export const REGIONS_STORE = signalStore(
  withState<RegionsState>(INITIAL_STATE),

  withMethods(
    (
      store,
      regionsService = inject(RegionsService),
      toastNotificationsService = inject(ToastNotificationsService)
    ) => ({
      list: rxMethod<void>(
        pipe(
          tap(() =>
            patchState(store, { loading: true, loaded: false, error: null })
          ),
          exhaustMap(() =>
            regionsService.list().pipe(
              tapResponse({
                next: regions => {
                  patchState(store, {
                    data: regions ?? [],
                    loading: false,
                    loaded: true,
                    error: null
                  });
                },
                error: (error: HttpErrorResponse) => {
                  toastNotificationsService.error('Loading regions failed');

                  patchState(store, {
                    loading: false,
                    loaded: true,
                    error
                  });
                }
              })
            )
          )
        )
      )
    })
  )
);
